import { isNil } from "@hopper-ui/components";
import { differenceInDays, getNow } from "@sg-protect/components";
import { useSession } from "./SessionProvider.tsx";

export function useDaysSinceExpiration(): number | null {
    const session = useSession();
    const endDate = session.products?.protect.subscription?.endDate;

    if (isNil(endDate)) {
        return null;
    }

    // A cancelled-but-not-yet-ended subscription can already be isInGracePeriod (grants read
    // access ahead of its EndDate) — clamp so "days since expiration" never goes negative.
    return Math.max(0, differenceInDays(getNow(), endDate));
}

export function useIsGracePeriod(): boolean {
    const session = useSession();

    return session.products?.protect.subscription?.isInGracePeriod ?? false;
}

export function useGracePeriodDays(): number {
    const session = useSession();

    return session.products?.protect.subscription?.gracePeriodDays ?? 0;
}
